import React, { useState, } from 'react';
import PropTypes from 'prop-types';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import AccountDetail from './AccountDetail';

const AccountDetailModal = ({ selectedAccount, }) => {
  const [ show, setShow, ] = useState(false);

  return (
    <>
      <Button variant='primary' onClick={() => setShow(true)}>
        Details
      </Button>
      <Modal show={show} onHide={() => setShow(false)} size="xl">
        <Modal.Header closeButton>
          <Modal.Title>Water Account Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <AccountDetail selectedAccount={selectedAccount} />
        </Modal.Body>
        <Modal.Footer />
      </Modal>
    </>
  );
};

AccountDetailModal.propTypes = {
  selectedAccount: PropTypes.instanceOf(Object).isRequired,
};

export default AccountDetailModal;
